var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { formatPersonWithOrgUnit } from '@web/components/Apps/SearchMeetings/utils';
import { ExportMenu } from '@web/components/layout/ExportMenu/ExportMenu';
import Loading from '@web/components/layout/Loading';
import PaginatedTable from '@web/components/layout/PaginatedTable/PaginatedTable';
import { WidgetTitle } from '@web/components/layout/WidgetTitle/WidgetTitle';
import { Tooltip } from '@web/components/ui/Tooltip';
import { PAGINATION_PAGE_SIZE } from '@web/config';
import { trpc } from '@web/lib/trpc';
import { itemDetailsUrl } from '@web/router/urls';
import { getIconByType, getLimitOffset, isAiButtonDisabled } from '@web/utility';
import { useFilters } from '@web/utility/hooks/useFilters';
import { useNavigateTo } from '@web/utility/hooks/useNavigateTo';
import { ApplicationEnum } from '@workalizer/shared';
import { InsightTypeEnum } from '@workalizer/shared/enums';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
export var formatAlertAction = function (action) {
    return action
        .replace('DOCUMENT_', '')
        .toLowerCase()
        .split('_')
        .map(function (word) { return word.charAt(0).toUpperCase() + word.slice(1); })
        .join(' ');
};
export var DocAlertsTable = function (_a) {
    var docSearchQuery = _a.docSearchQuery;
    var t = useTranslation().t;
    var navigateTo = useNavigateTo();
    var _b = useFilters(), dateFrom = _b.dateFrom, dateTo = _b.dateTo, orgUnit = _b.orgUnit, user = _b.user, page = _b.page;
    var _c = getLimitOffset(page, PAGINATION_PAGE_SIZE), limit = _c.limit, offset = _c.offset;
    var documentAlertsList = trpc.documentAlertsList.useQuery({
        dateFrom: dateFrom,
        dateTo: dateTo,
        orgUnitId: orgUnit,
        triggeredBy: user,
        searchQuery: docSearchQuery,
        limit: limit,
        offset: offset
    });
    if (documentAlertsList.isLoading || !documentAlertsList.data) {
        return _jsx(Loading, {});
    }
    var columns = [
        {
            title: t('docAlerts.triggered'),
            isVisible: true,
            className: 'sm:px-3'
        },
        {
            title: t('docAlerts.alerts'),
            isVisible: true,
            className: 'sm:px-3'
        },
        {
            title: t('docAlerts.event'),
            isVisible: true,
            className: 'sm:px-3'
        },
        {
            title: t('docAlerts.triggeredBy'),
            isVisible: true,
            className: 'sm:px-3'
        }
    ];
    var tableData = documentAlertsList.data.data.map(function (alert) { return [
        {
            id: 'triggered',
            render: function () { return (_jsx("span", __assign({ className: "text-gray-500 text-sm leading-5 font-normal whitespace-nowrap" }, { children: format(new Date(alert.date), 'dd MMM HH:mm') }))); }
        },
        {
            id: 'alerts',
            render: function () { return (_jsxs("div", __assign({ className: "flex min-w-0 items-center gap-2 text-gray-500" }, { children: [_jsx("span", __assign({ className: "shrink-0" }, { children: getIconByType(alert.document.type, { width: '15', height: '15' }) })), _jsx(Tooltip, __assign({ content: t('docAlerts.openDocumentDetails') }, { children: _jsx("button", __assign({ type: "button", className: "min-w-0 truncate text-left text-sm leading-5 font-normal text-gray-700 underline decoration-dashed decoration-gray-400 underline-offset-2 cursor-pointer hover:text-indigo-600 hover:decoration-indigo-600", onClick: function () {
                                return navigateTo({
                                    pathname: itemDetailsUrl,
                                    newFilters: {
                                        itemId: alert.document.id,
                                        app: ApplicationEnum.DRIVE,
                                        page: page
                                    }
                                });
                            } }, { children: alert.document.title })) }))] }))); }
        },
        {
            id: 'event',
            render: function () { return (_jsx("span", __assign({ className: "text-gray-500 text-sm leading-5 font-normal" }, { children: formatAlertAction(alert.event) }))); }
        },
        {
            id: 'triggeredBy',
            render: function () {
                var displayName = alert.triggeredBy.name || alert.triggeredBy.email;
                var orgUnitTitle = alert.triggeredBy.orgUnitTitle;
                return (_jsxs("span", __assign({ className: "text-sm leading-5 text-gray-900" }, { children: [_jsx("span", __assign({ className: "font-semibold" }, { children: displayName })), orgUnitTitle ? (_jsxs("span", __assign({ className: "font-normal" }, { children: [" (", orgUnitTitle, ")"] }))) : null] })));
            }
        }
    ]; });
    return (_jsxs("div", { children: [_jsx(WidgetTitle, { title: "insights.tables.docAlertsTable", description: "widgetTitleDescriptions.apps.docAlertsTable", insightType: InsightTypeEnum.docAlertsTable, insightsData: documentAlertsList.data, refetch: documentAlertsList.refetch, csvExport: _jsx(ExportMenu, { fileName: t('insights.tables.docAlertsTable'), onExportHandler: function () { return __awaiter(void 0, void 0, void 0, function () {
                        var _a, _b;
                        return __generator(this, function (_c) {
                            return [2 /*return*/, ((_b = (_a = documentAlertsList.data) === null || _a === void 0 ? void 0 : _a.data) !== null && _b !== void 0 ? _b : []).map(function (alert) {
                                    var _a;
                                    return (_a = {},
                                        _a[t('docAlerts.triggered')] = format(new Date(alert.date), 'yyyy-MM-dd HH:mm'),
                                        _a[t('docAlerts.alerts')] = alert.document.title,
                                        _a[t('docAlerts.event')] = formatAlertAction(alert.event),
                                        _a[t('docAlerts.triggeredBy')] = formatPersonWithOrgUnit({
                                            name: alert.triggeredBy.name,
                                            email: alert.triggeredBy.email,
                                            orgUnitTitle: alert.triggeredBy.orgUnitTitle,
                                            externalLabel: ''
                                        }),
                                        _a);
                                })];
                        });
                    }); }, disabled: isAiButtonDisabled(documentAlertsList.data) }) }), _jsx(PaginatedTable, { columns: columns, data: tableData, total: documentAlertsList.data.total, typeResultText: t('docAlerts.docAlerts'), pageSize: PAGINATION_PAGE_SIZE })] }));
};
